import { render, staticRenderFns } from "./forgot_pass.vue?vue&type=template&id=61c18abf&scoped=true"
import script from "./forgot_pass.vue?vue&type=script&lang=js"
export * from "./forgot_pass.vue?vue&type=script&lang=js"
import style0 from "./forgot_pass.vue?vue&type=style&index=0&id=61c18abf&prod&lang=css"
import style1 from "./forgot_pass.vue?vue&type=style&index=1&id=61c18abf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c18abf",
  null
  
)

export default component.exports